import React, { useEffect, useState } from "react";
import Button from "../../../core/Button/Button";
import SliderPanelUtils from "../SliderPanelUtils";
import { SliderPanelItemModel } from "../SliderPanelModel";
import { ProductModel } from "../../ShowcasePanel/ShowcasePanelModel";

import "./SliderPanelItem.css";
import Utils from "../../../core/Utils/Utils";
import { ButtonModel } from "../../../core/Models/ButtonModel";

const SliderPanelItem: React.FC<{
  blok: SliderPanelItemModel;
  selectedItem: string;
  displayAnnuallyOrMonthlySwitch: boolean;
  isChecked: boolean;
  onClick?: () => void;
}> = ({
  blok,
  selectedItem,
  displayAnnuallyOrMonthlySwitch,
  isChecked,
  onClick,
}) => {
  const [price, setPrice] = useState("");
  const [buttons, setButtons] = useState<ButtonModel[]>([]);
  const productEntity = blok.entity[0]?.content as ProductModel;
  const featureIndex = SliderPanelUtils.getFeatureIndex(
    productEntity,
    blok.tier
  );

  const subscriptionIndex = SliderPanelUtils.getSubscriptionIndex(
    productEntity,
    blok.tier
  );
  const monthlyValue =
    subscriptionIndex &&
    productEntity?.subscriptionIntervalPrice?.tbody &&
    productEntity?.subscriptionIntervalPrice.tbody.length > 0
      ? productEntity.subscriptionIntervalPrice.tbody[0]?.body[
          subscriptionIndex
        ]?.value
      : null;
  const annuallyValue =
    subscriptionIndex &&
    productEntity?.subscriptionIntervalPrice?.tbody &&
    productEntity.subscriptionIntervalPrice.tbody.length > 2
      ? productEntity.subscriptionIntervalPrice.tbody[2]?.body[
          subscriptionIndex
        ]?.value
      : null;
  const monthlyFormattedValue = monthlyValue ? `$${monthlyValue}/mo` : "";
  const annuallyFormattedValue = annuallyValue ? `$${annuallyValue}/yr` : "";

  useEffect(() => {
    setPrice(
      SliderPanelUtils.getPrice(
        productEntity,
        displayAnnuallyOrMonthlySwitch,
        monthlyValue,
        annuallyValue,
        isChecked,
        monthlyFormattedValue,
        annuallyFormattedValue
      )
    );
  }, [
    productEntity,
    displayAnnuallyOrMonthlySwitch,
    monthlyValue,
    annuallyValue,
    isChecked,
    monthlyFormattedValue,
    annuallyFormattedValue,
  ]);

  useEffect(() => {
    if (displayAnnuallyOrMonthlySwitch) {
      if (isChecked) {
        setButtons(
          blok.buttons.filter(
            (x) =>
              !x.displayFor || x.displayFor.toLowerCase().indexOf("month") > -1
          )
        );
      } else {
        setButtons(
          blok.buttons.filter(
            (x) =>
              !x.displayFor || x.displayFor.toLowerCase().indexOf("annual") > -1
          )
        );
      }
    } else {
      setButtons(blok.buttons);
    }
  }, [displayAnnuallyOrMonthlySwitch, isChecked, blok.buttons]);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onClick) {
      onClick();
    }
  };

  if (
    !blok?.entity ||
    blok.entity.length < 1 ||
    featureIndex < 0 ||
    (subscriptionIndex < 0 && productEntity.productType === "Subscription")
  ) {
    return null;
  }

  return (
    <div
      className={`slider-panel-item ${
        selectedItem === productEntity.productName + blok.tier ? "selected" : ""
      }`}
      onClick={handleClick}
    >
      {blok.image?.filename && (
        <img
          src={Utils.getCacheUrl(blok.image?.filename)}
          alt=""
          onError={(e) => Utils.handleImageError(e, blok.image?.filename)}
        />
      )}
      <div>
        <div className="item-title">
          <span>
            {productEntity.productName} {blok.tier}
          </span>
          <span className="price">{price}</span>
        </div>
        <div className="feature-text-container">
          {productEntity.featureList?.tbody.map((tbody) => {
            if (
              !tbody?.body[featureIndex].value ||
              tbody?.body[featureIndex].value === "x"
            ) {
              return null;
            }
            const text = tbody.body[0].value;
            const value = tbody.body[featureIndex].value;
            return (
              <div
                className="feature-text"
                key={`item-feature-${blok.tier}-${blok.productName}-${text}`}
              >
                - {text} {value}
              </div>
            );
          })}
        </div>
      </div>
      {buttons && buttons.length > 0 && (
        <div className="action-buttons">
          {buttons.map((button) => {
            return <Button blok={button} key={button._uid} />;
          })}
        </div>
      )}
    </div>
  );
};

export default SliderPanelItem;
